/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {
  'use strict';


})(jQuery, Drupal);
